<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="배송비 조건 조회"
      desc="등록한 배송비 조건들의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end">
      <button @click="$router.push(`deliveryprice/create`)"
              class="button is-primary">배송비조건 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1808"
                 @check="clickCheckBox"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="name" slot-scope="props">
        <div>{{ props.item.name }}</div>
        <div v-if="props.item.is_base">(기본설정)</div>
      </div>

      <!-- 배송비 방식 -->
      <div slot="delivery_method" slot-scope="props">
        <div>
          <span v-for="(name,idx) in props.item.delivery_method"
                :key="'delivery_method-'+idx">{{ deliveryMethodName(name) }}
            <span v-if="idx<props.item.delivery_method.length-1">,</span>
          </span>
        </div>
      </div>

      <!-- 배송비 유형 -->
      <div slot="delivery_type" slot-scope="props">
        <div v-if="props.item.delivery_type===0">고정배송비</div>
        <div v-else-if="props.item.delivery_type===1">배송비무료</div>
        <div v-else-if="props.item.delivery_type===2">금액별</div>
        <div v-else-if="props.item.delivery_type===3">수령별</div>
        <div v-else-if="props.item.delivery_type===4">무게별</div>
      </div>

      <!-- 배송비 부과 방법 -->
      <div slot="tax_method" slot-scope="props">
        <div v-if="props.item.tax_method===0">배송비조건별</div>
        <div v-else-if="props.item.tax_method===1">상품별</div>
      </div>

      <!-- 배송비 결제 방법 -->
      <div slot="pay_type" slot-scope="props">
        <div v-if="props.item.pay_type===0">선불</div>
        <div v-else-if="props.item.pay_type===1">착불</div>
        <div v-else-if="props.item.pay_type===2">선불/착불</div>
      </div>


      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickModifyDelete(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger" @click.stop.prevent="clickModifyDelete(props.item,'delete')">삭제</button>
      </div>
    </admin-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  export default {
    name: "delivery-price-list",
    mixins: [
      ListMixin
    ],
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('deliveryprice', 'product/deliveryprice?partner_null=true');
      },
      getDataFromServer() {
        this.getData();
      },
      deliveryMethodName(name) {
        switch(name) {
          case 'parcel': return '택배'
          case 'post': return '등기,소포'
          case 'cargo': return '화물배송'
          case 'visit': return '방문수령'
          case 'quick': return '퀵'
          case '': return ''
        }
      },
      clickModifyDelete(item, type) {
        if(type === 'update') {
          this.$router.push(this.getPath(`deliveryprice/create?id=${item.id}`));
        }
        else if(type === 'delete') {
          let value = {
            url: `product/deliveryprice/${item.id}`,
            title: `${item.name} 배송조건을 삭제하시겠습니까?`
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
    }
  }
</script>

<style scoped>

</style>
